import React, {useState, useRef, useEffect} from 'react';
import PropTypes from 'prop-types';
import {emailRegex, rutRegex} from 'config';
import PubSub from 'services/PubSub/';
import LoginService from 'services/Login/';
import Input from 'components/Input';
import PersistentCart from 'services/PersistentCart';
import Loader from 'components/Loader';
import { actionsType } from 'config/constants';
import TagManagerService from 'services/TagManager';
import { modalLoginTxt } from 'config/translate/variables';
import NewRelicService from 'services/NewRelic'
import style from './style.scss';//NOSONAR

let emailValid = false;
let withRut = false;

const FormLogin = (props) => {

    const [formIsValid, setFormIsValid] = useState(false);
    const [loader, setLoader] = useState(false);
    const [showInvalidPassword, setShowInvalidPassword] = useState(false);
    const [messageBlocked, setMessageBlocked] = useState(false);
    const [showInvalidRut, setShowInvalidRut] = useState(false);
    const [settings, setSettings] = useState({successCallback: false});
    const [inputPasswordValid, setInputPasswordValid] = useState(false);

    let inputEmail = useRef('');
    let inputPassword = useRef('');
    const payload = props.payload;
    const urlCallback = props.urlCallback;

    useEffect(() => {
        if (payload) {
            setSettings(payload);
        }
    },[payload]);

    useEffect(() => {
        return function cleanup() {
            emailValid = false;
            withRut = false;
        }
    }, [])

    const _getEmailIsValid = (isValid) => {
        emailValid = isValid;
    }

    const _getEmailIsPassword = (isValid) => {
        setInputPasswordValid(isValid)
    }


    const validateForm = () => {
        const isvalid = (emailValid  && inputPasswordValid);

        if (isvalid !== formIsValid) {
            setFormIsValid(isvalid);
            setShowInvalidPassword(false);
            setMessageBlocked(false);
        }
        if (showInvalidRut) {
            setShowInvalidRut(false);
        }
    }

    const goForgotPassword = () => {
        const email = inputEmail.current;

        if(!email) return false;

        if (emailValid) {
            _goForgotPassword(email.value);
        } else {
            inputEmail.current.focus();
            inputEmail.current.blur();
            inputEmail.current.focus();
        }
    }

    const _goForgotPassword = (email) => {
        TagManagerService.logAccount('Ingresa a tu cuenta', 'Olvidaste tu clave', window.location.href);

        setTimeout(()=> PubSub.dispatch('forgot_password_open', {
            email
        }),0);

        _closeModal();
    }

    const validateEmail = (value) => {
        let isValid = true;

        withRut = rutRegex.test(value);

        if (!(emailRegex.test(value) || withRut)) {
            isValid = false;
        }

        return isValid;
    }

    const _closeModal = () => {
        setTimeout(()=> PubSub.dispatch(actionsType.MODAL.LOGIN_CLOSE),0);
    }

    const goRegister = () => {
        _closeModal();

        PubSub.dispatch('register_open');
        TagManagerService.logAccount('Ingresa a tu cuenta', 'registrate', window.location.href);
    }

    const validatePassword = (value) => {
        return value.length > 3;
    }

    const loginSuccess = (isNextStep) => {
        let info = {}

        if (settings) {
            info.successCallback = settings.successCallback;
        }

        if (isNextStep) {
            PubSub.dispatch('modal_persist_address_open', info);
        }

        PubSub.dispatch('toggle_menu', {state:false});

        TagManagerService.logAccount('Ingresa a tu cuenta', 'ingresa', window.location.href);
    }

    const userLogin = (data) => {
        const user = data[0];
        const password = data[1];
        return LoginService.userAuthentication(user, password)
            .then(response => {
                if (response.authStatus === 'WrongCredentials') {
                    setShowInvalidPassword(true)
                } else if (response.authStatus === 'BlockedUser') {
                    setMessageBlocked(true);
                }

                return response

            });

    }

    const handleSubmitForm = (event = false) => {
        if (event) {
            event.preventDefault();
        }
        const data = [];

        data.push(inputEmail.current.value);
        data.push(inputPassword.current.value);

        _sendLogin(data);
    }

    const _sendLogin = (data) => {
        NewRelicService.sendPageAction({
            action: 'login',
            payload: {
                status: 'init',
                email: data[0]
            },
            noAuth: true
        });

        userLogin(data)
            .then(response => {
                if (response && response.token && response.user) {
                    PersistentCart.verifyPersistentOrderForm(response, (isNextStep = true) => {
                        setLoader(false);
                        _closeModal()


                        LoginService.setLogin(response);
                        loginSuccess(isNextStep);

                        NewRelicService.sendPageActionNoAuth({
                            action: 'login',
                            payload: {
                                status: response.authStatus || 'Success',
                                email: response && response.user && response.user.email ? response.user.email : data[0]
                            }
                        });
                        
                        if(urlCallback) {
                            window.location.href = urlCallback;
                        }
                    }, () => {
                        _closeModal();

                    }, urlCallback);
                } else {
                    setLoader(false);

                    NewRelicService.sendPageActionNoAuth({
                        action: 'login',
                        payload: {
                            status: response && !response.status ? response.authStatus : 'Error',
                            email: response && response.user && response.user.email ? response.user.email : data[0]
                        }
                    });
                }
            });
        setLoader(true);
    }

    const subtitle = props.subtitle;
    return (
        <form className="new-modal-container" onSubmit={handleSubmitForm}>
            {loader && <div className="login-loader"><Loader/></div>}
            <div className={'new-modal-scroll'}>
                <h3 className="new-modal-title">{modalLoginTxt.title}</h3>
                {(urlCallback === '/_secure/cart') && subtitle && <span className="modal-login-subtitle">{subtitle}</span>}
                <span className="modal-login-message">{modalLoginTxt.message}</span>
                <div className={'login-wrap'}>
                    <Input
                        ref={inputEmail}
                        key={'email'}
                        className={''}
                        name={'email'}
                        label={'Mail o Rut'}
                        value={''}
                        type={'text'}
                        validate={validateEmail}
                        onChange={() => { return true}}
                        message={{
                            "error": "Ingresa un mail o RUT válido"
                        }}
                        validateForm={validateForm}
                        callbackValidate={_getEmailIsValid}
                    />
                    <Input
                        ref={inputPassword}
                        key={'Clave'}
                        className={''}
                        name={'Clave'}
                        label={'Clave'}
                        value={''}
                        type={'password'}
                        onChange={validatePassword}
                        message={{
                            "error": "Campo obligatorio"
                        }}
                        validateForm={validateForm}
                        callbackValidate={_getEmailIsPassword}
                    />

                    {(formIsValid && showInvalidPassword) &&
                    <p className="error-password">Mail o clave incorrecta</p>}

                    {(formIsValid && messageBlocked) &&
                    <p className="error-password">Ingresaste una clave incorrecta tres veces. Tu usuario ha sido bloqueado por 1 hora, prueba más tarde</p>}

                    {(showInvalidRut) &&
                    <p className="login-invalid-rut">RUT no reconocido, <strong>regístrate</strong> o comunícate
                        con <strong>Servicio al Cliente</strong></p>}
                    
                </div>
                <button type="button" className="btn-link" onClick={goForgotPassword}>
                    <span>{modalLoginTxt.forgot}</span>
                </button>
            </div>
            <div className="modal-actions">
                <button type="button" className="secundary-btn" onClick={goRegister}>
                    <span className="btn-span-register">{modalLoginTxt.btnCancel}</span>
                </button>
                <button type="submit" className={formIsValid ? 'primary-btn' : 'disabled-btn'}>
                    <span className="btn-span-enter">{modalLoginTxt.btnSubmit}</span>
                </button>
            </div>
        </form>
    )

}

FormLogin.propTypes = {
    payload: PropTypes.object,
    subtitle: PropTypes.string,
    urlCallback: PropTypes.string
}
export default FormLogin;
